<template>
    <Modal ref="modal">
        <template #title>Design Options</template>

        <WysiwygContent :content="richTextToHtml(props.designOptionsHelp)" />
    </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/Modal.vue';
import { richTextToHtml } from '~/utils/storyblok';

const modal = ref<InstanceType<typeof Modal> | null>(null);

const props = defineProps<{
    designOptionsHelp: string;
}>();

defineExpose({
    open: () => modal.value?.open(),
});
</script>
